import { ListArPaymentDetailsByProResp } from '@xpo-ltl/sdk-accountsreceivable';

export class PaymentHistoryData {
  pickupDate: any;
  arrPayDet: ListArPaymentDetailsByProResp;
  custMadCd: string;
}
